import $ from 'jquery'

export default {
  init() {
    $('.open-menu').on('click', (e) => {
      const menuOpened = $('.pole-menu-responsive').height() > 50
      if(menuOpened){
        $('.pole-menu-responsive').css({ height: 50 });
        $('.open-menu').css({ transform: 'rotate(0deg)' });
      } else {
        const height = $('.pole-menu-responsive-content').height();
        $('.pole-menu-responsive').css({ height: height + 50 });
        $('.open-menu').css({ transform: 'rotate(90deg)' });
      }
    })

    setTimeout(() => {
      $('.block-success').fadeOut();
    }, 2000)
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/le-pole-detail.js